import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { CalendarData } from '../types';

export const isValidCalendarObject = (obj: CalendarData): boolean =>
  Boolean(obj?.data?.getSdapiCalendarWidget && !isEmptyObject(obj.data.getSdapiCalendarWidget));